module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Team ro.499f06d8.svg";